import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import AuthStore from '../../../../stores/AuthStore';
const fields = [
    {
        name: 'email',
        type: 'email',
        label: 'modals:offerRequest.email',
        placeholder: 'modals:offerRequest.emailPlaceholder',
        value: '',
        rules: 'required|email'
    }
];
const hooks = {
    onSuccess: (form) => {
        const { email } = form.values();
        return AuthStore.resetPassword(email);
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnBlur: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
